import { AxiosRequestConfig } from "axios";
import Cookies from 'js-cookie';
import { getRegion } from "../components/regionWrapper";
import { Region } from "../utils/commonInterfaces";
import { getExportAxiosRequestByRegion } from "../utils/getExportAxiosRequestByRegion";

export const request = ({
  url,
  method,
  data,
  params,
  headers,
}: AxiosRequestConfig) => {
  return async (_dispatch: any) => {
    const region = getRegion();
    const axios = getExportAxiosRequestByRegion(region as Region);
    return new Promise(async (resolve, reject) => {
      const axiosObj: AxiosRequestConfig = {
        url,
        method,
        ...(data && { data }),
        ...(params && {
          params: {
            ...params,
          },
        }),
        headers: region === Region.EG ? {
          Authorization: `Bearer ${Cookies.get('token')}`,
          ...(headers && {
            ...headers,
          })
        } : {
          ...(headers && {
            ...headers,
          }),
        },
        ...(region === Region.SE && { withCredentials: true }),
      };

      try {
        const res = await axios(url as string, axiosObj);
        resolve(res);
      } catch (e) {
        reject(e);
      }
    });
  };
};
